import { Box } from "@mui/material";

function AppliedText() {
  return (
    <Box
      sx={{
        borderRadius: "10px",
        textTransform: "none",
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        fontWeight: 600,
        fontSize: 16,
        px: 3,
        py: 1,
        zIndex: 1,
        minWidth: 118,
        textAlign: "center"
      }}
    >
      Applied
    </Box>
  );
}

export default AppliedText;
